/*
 *
 * LanguageProvider constants
 *
 */
export const CHANGE_LOCALE = 'app/components/LanguageToggle/CHANGE_LOCALE';



// WEBPACK FOOTER //
// ./src/components/LanguageProvider/constants.js